import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';

import TitleWithShape from 'components/TitleWithShape';
import IconButton from 'components/IconButton';
import HelpText from 'components/HelpText';
import BackButton from 'components/BackButton';
import DatePicker from 'components/DatePicker';
import Dropdown from 'components/Dropdown';

const Wrapper = styled.div`
  color: #35447d;
  display: flex;
  justify-content: center;
  padding-left: 5.4rem;
  padding-right: 5.4rem;
  margin-top: 7.1rem;
  .form-wrapper {
    background: #F8F7F3;
    width: 66rem;
    height: 80rem;
    position: relative;
    padding: 10rem 8rem;
    .bar-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      top: 3rem;
      right: 2.5rem;
      left: 2.5rem;
    }
    .content {
      margin-top: 5rem;
      display: flex;
      position: absolute;
      width: 100rem;
      .preference {
        width: 36rem;
        background: #e1e1e1;
        padding: 4rem 4rem 4.5rem 4rem;
        margin-right: 2rem;
        .header {
          display: flex;
          justify-content: flex-end;
          margin-right: -2rem;
        }
        .name {
          font-size: 1.8rem;
          margin-bottom: 2rem;
        }
        .times {
          display: flex;
          justify-content: space-between;

          .block {
            padding: 4px 12px;
          }
        }
      }
      .next-button {
        margin-top: 5rem;
        display: flex;
        justify-content: flex-end;
      }
    }
    .button-wrapper {
      display: flex;
      justify-content: flex-end;
      margin-top: 40rem;
    }
  }
  .info-wrapper {
    margin-top: 6rem;
    margin-left: 12rem;
    width: 36rem;
    h3 {
      font-size: 1.8rem;
      font-weight: 400;
      letter-spacing: 1px;
    }
  }

  @media only screen and (max-width: 1100px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    .form-wrapper {
      height: auto;
      .content {
        width: auto;
        position: relative;
        flex-direction: column;
        align-items: center;
        .times {
          flex-direction: column;
          .block {
            padding: 10px;
          }
        }
        .preference {
          margin-bottom: 2rem;
        }
      }
      .button-wrapper {
        margin-top: 8rem;
      }
    }
    .info-wrapper {
      margin-top: 1rem;
      margin-bottom: 6rem;
      margin-left: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
    .form-wrapper {
      height: auto;
      .description {
        width: auto;
      }
    }
  }
`;

const timeOptions = [
  { value: '10:00 am' },
  { value: '10:30 am' },
  { value: '11:00 am' },
  { value: '11:30 am' },
  { value: '12:00 pm' },
  { value: '12:30 pm' },
  { value: '1:00 pm' },
  { value: '1:30 pm' },
  { value: '2:00 pm' },
  { value: '2:30 pm' },
  { value: '3:00 pm' },
];

class Step7 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData;
    // Defaults
    this.state.changesMade = this.state.changesMade || false;
    if (this.state.preferences === undefined) {
      const defaultArray = [];
      for (let i = 0; i < 3; i++) {
        defaultArray.push({
          date: new Date(),
          between: '1:00 pm',
          and: '2:00 pm',
        });
      }
      this.state.preferences = defaultArray;
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChangeEvent(e, index, key, target = false) {
    if (!this.state.changesMade) {
      this.setState({ changesMade: true });
    }
    const array = this.state.preferences.slice();
    if (target) { array[index][key] = e; }
    else { array[index][key] = e.target.value; }
    this.setState({ preferences: array });
  }

  nextFormPage() {
    this.setState({ completed: true }, () => {
      this.props.collectData('step7', this.state);
      this.setState({ redirect: '/get-started/step-eight' });
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    return (
      <Wrapper>
        <div className="form-wrapper">
          <div className="bar-wrapper">
            <BackButton />
          </div>
          <TitleWithShape
            title="Book a video conference"
            subTitle="Please select three preferences for the date and time you would like to speak to a solicitor, to discuss your question and diagnose your legal issue."
          />
          <div className="content">
            {this.state.preferences.map((obj, i) => (
              <div className="preference" key={i}>
                <div className="header">
                  {/* <img alt="close-button" src={CloseIcon} /> @TODO: Reduce top padding when this goes in... */}
                </div>
                <div className="name">Preference #{i + 1}</div>
                <DatePicker
                  hint="Date"
                  onChange={e => this.onChangeEvent(e, i, 'date', true)}
                  value={obj.date}
                  isRequired
                />
                <div className="times">
                  <Dropdown hint="Between" options={timeOptions} value={obj.between} onChange={e => this.onChangeEvent(e, i, 'between')} />
                  <span className="block" />
                  <Dropdown hint="And" options={timeOptions} value={obj.and} onChange={e => this.onChangeEvent(e, i, 'and')} />
                </div>
              </div>
            ))}
          </div>
          <div className="button-wrapper" >
            <IconButton
              name="Save and review brief"
              icon="downArrow"
              width={23}
              onClick={() => this.nextFormPage()}
              disabled={!this.state.changesMade}
              selected
              noBorder
            />
          </div>
        </div>
        <div className="info-wrapper">
          <HelpText>You're almost done</HelpText>
          <h3>After you select three preferences for a video conference, you can review your brief and finalise payment.</h3>
        </div>
      </Wrapper>
    );
  }
}

Step7.propTypes = {
  collectData: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Step7;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step7.js